// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { multiTextWidgetStyles } from "@synd/App/Widgets/Basic/MultiTextWidget";
import PaginationRightArrow from "@synd/XDL/Icons/PaginationRightArrow";
import { fontConfig } from "@synd/XDL/PreStyle/typography";
import { color, createLinkIconStyles, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

multiTextWidgetStyles.container = {
    css: css`
        display: flex;
        align-items: stretch;
        justify-content: center;
        gap: 24px;

        ${xScreen("lte", "sm")} {
            flex-direction: column;
        }
    `,
};

multiTextWidgetStyles.sectionTitle = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${fontConfig.smallHeadLine.size}px;
            line-height: ${fontConfig.smallHeadLine.lineHeight};
            font-weight: ${fontConfig.weight.semiBold};
            margin-bottom: 4px;
        }
    `,
};

multiTextWidgetStyles.sectionDescription = {
    css: css`
        &,
        ${TypographyStyle} {
            font-size: ${fontConfig.smallSingleLine.size}px;
            line-height: ${fontConfig.smallSingleLine.lineHeight};
            color: ${color("common.text")};
            margin-bottom: 4px;
        }
    `,
};

multiTextWidgetStyles.sectionLink = {
    ...createLinkIconStyles({
        icon: PaginationRightArrow,
        sizeVariant: "xsmall",
        variant: "primary",
        linkStyles: {
            icon: {
                iconProps: {
                    size: 9,
                    css: css`
                        &,
                        & > svg {
                            width: 5px;
                            height: 11px;
                        }
                    `,
                },
                position: "right",
            },
        },
    }),
};
